import React, {Component} from 'react';
import { withTranslation, Trans } from 'react-i18next';

class WarningConfirm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active : false,
            style : {
                display : 'none'
            }
        };
    }

    componentDidMount() {
        console.log(`this.props.showCancelbutton1: ${this.props.showCancelbutton}`);
        this.setState({
            ...this.state,
            style : {
                display : 'block'
            },
            showCancelbutton: this.props.showCancelbutton
        });

        document.documentElement.classList.add('modal-open');

        setTimeout(() => {
            console.log(`this.props.showCancelbutton2: ${this.props.showCancelbutton}`);
            this.setState({
                ...this.state,
                active : true,
                showCancelbutton: this.props.showCancelbutton
            });
        }, 500);
    }

    onClickConfirm = () => {
        this.setState({
            ...this.state,
            active : false
        });

        document.documentElement.classList.remove('modal-open');

        this.props.onClickConfirm();
    };

    render() {
        const {
            title,
            confirmButtonText,
            t,
            i18n
        } = this.props;
        return (
            <div
                className={`modal modal-message ${this.state.active ? 'show' : ''}`}
                style={this.state.style}
                onTransitionEnd={() => {
                    if(!this.state.active) {
                        this.onClickConfirm();
                    }
                }}>
                <div className={"modal-dialog"}>
                    <div className={"modal-header"}>
                        <h5 className={"modal-title"}>
                            {t(`common::label::${"Warning"}`)}
                        </h5>
                        <button type={"button"}
                            className={"btn-close"}
                            onClick={() => {
                                this.onClickConfirm();
                            }}>
                            <i className={"sprite sprite-cancel-lg"}/>
                        </button>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"message-description"}>
                            <i className={"sprite sprite-notification"}></i>
                            <div>
                                <strong>
                                    {this.props.renderMessage && typeof this.props.renderMessage === "function" &&
                                        this.props.renderMessage(this.props)
                                    }
                                </strong>
                            </div>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            type={"button"}
                            className={"btn btn-primary"}
                            onClick={(e) => {
                                this.onClickConfirm(true);
                            }}>
                            <span>{t(`common::label::Confirm`)}</span>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(WarningConfirm);
